var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5259 35.7547C29.194 35.7547 33.7889 31.2045 33.7889 25.5915C33.7889 19.9785 29.194 15.4282 23.5259 15.4282C17.8578 15.4282 13.263 19.9785 13.263 25.5915C13.263 31.2045 17.8578 35.7547 23.5259 35.7547ZM23.5259 35.7547H3M14.6311 20.4968C11.7971 25.3578 13.479 31.5736 18.3876 34.3801C23.2963 37.1866 29.5731 35.5211 32.4071 30.6601C35.2411 25.7991 33.5593 19.5833 28.6506 16.7768C23.7419 13.9703 17.4652 15.6358 14.6311 20.4968ZM14.6311 20.4968L24.8941 2.89355M32.4073 20.5035C29.5733 15.6425 23.2965 13.977 18.3878 16.7835C13.4791 19.59 11.7973 25.8057 14.6313 30.6667C17.4654 35.5277 23.7421 37.1932 28.6508 34.3867C33.5595 31.5802 35.2413 25.3645 32.4073 20.5035ZM32.4073 20.5035L42.6702 38.1067",
    stroke: "white",
    strokeWidth: 5.13526,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/BrandLogo.e6349f4ebf762becfcf09eb28c396dcc.svg";
export { ForwardRef as ReactComponent };